import React from 'react';

export function RouteLoadingFallback() {
  return (
    <main
      className="flex min-h-screen items-start justify-center bg-slate-50 px-4 py-10 sm:items-center"
      aria-busy="true"
    >
      <section
        className="w-full max-w-xl rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
        role="status"
        aria-live="polite"
        aria-label="Loading AffinityAI"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-700">
          AffinityAI
        </p>
        <h1 className="mt-3 text-2xl font-semibold text-slate-950">Opening your workspace…</h1>
        <p className="mt-2 text-sm leading-6 text-slate-600">Bold decisions, made together.</p>
        <div className="mt-7 space-y-3" aria-hidden="true">
          <div className="h-3 w-4/5 animate-pulse rounded-full bg-slate-200" />
          <div className="h-3 w-full animate-pulse rounded-full bg-slate-100" />
          <div className="h-3 w-3/5 animate-pulse rounded-full bg-slate-100" />
        </div>
      </section>
    </main>
  );
}

export class RouteLoadBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    console.error('route_chunk_load_failed', {
      errorCategory: 'route_chunk_load_failed',
    });
  }

  handleReload = () => {
    if (this.props.reloadPage) {
      this.props.reloadPage();
      return;
    }
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="flex min-h-screen items-start justify-center bg-slate-50 px-4 py-10 sm:items-center">
        <section
          className="w-full max-w-xl rounded-3xl border border-amber-200 bg-white p-6 shadow-sm sm:p-8"
          role="alert"
          aria-live="assertive"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-700">
            AffinityAI
          </p>
          <h1 className="mt-3 text-2xl font-semibold text-slate-950">
            AffinityAI needs a quick refresh
          </h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">
            A newer version may be available. Reload this page to continue safely.
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              className="inline-flex min-h-11 items-center justify-center rounded-full bg-slate-950 px-6 text-sm font-semibold text-white transition hover:bg-slate-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={this.handleReload}
            >
              Reload AffinityAI
            </button>
            <a
              className="inline-flex min-h-11 items-center justify-center rounded-full border border-slate-300 bg-white px-6 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              href="/"
            >
              Go to homepage
            </a>
          </div>
        </section>
      </main>
    );
  }
}

export default RouteLoadBoundary;
